import { createContext, useContext, useEffect, useState } from "react";

type Ctx = { warming: boolean };

const DbWakeContext = createContext<Ctx>({ warming: false });

// Module-level setter so non-React code (axios interceptors) can flip the banner.
let externalSetWarming: (b: boolean) => void = () => {};
export const setDbWarming = (b: boolean) => externalSetWarming(b);

export const DbWakeProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [warming, setWarming] = useState(false);

  useEffect(() => {
    externalSetWarming = setWarming;
    return () => {
      externalSetWarming = () => {};
    };
  }, []);

  return (
    <DbWakeContext.Provider value={{ warming }}>
      {children}
    </DbWakeContext.Provider>
  );
};

export const useDbWake = () => useContext(DbWakeContext);
